import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  EtrmConfigActionEnum,
} from '.';
import {
    ConfigurationManagementEnum,
     IEtrmConfig,
} from '../../services';
import { FetchEtrmConfigFailedAction, FetchEtrmConfigSuccessAction, PostEtrmConfigFailedAction, PostEtrmConfigSuccessAction } from './ActionCreator';
import { EtrmConfigService } from '../../services/EtrmConfig.Service';
import { toast } from 'react-toastify';

const etrmConfigService = new EtrmConfigService();

export const fetchEtrmConfigEpic = (action$: any) =>
  action$.pipe(
    ofType(EtrmConfigActionEnum.FetchEtrmConfig),
    switchMap(() => {
      const etrmConfigs = etrmConfigService.getAllEtrmConfig()
      return etrmConfigs;
    }),
    map((response: IEtrmConfig[]) => {
      return FetchEtrmConfigSuccessAction(response);
    }),
    catchError((x) => {
      console.error(x);
      return of(FetchEtrmConfigFailedAction(ConfigurationManagementEnum.UnableToGetEtrmConfig));
    })
  );

export const postEtrmConfigEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(EtrmConfigActionEnum.PostEtrmConfig),
    withLatestFrom(state$),
  switchMap(([action]) => {
    if (action?.state?.etrmConfig) {
      const response = etrmConfigService.postEtrmConfigUpdate(action.state.etrmConfig);
      return response;
    }
    else {
      toast.error(ConfigurationManagementEnum.UnableToGetEtrmConfig, { autoClose: 3000, draggable: true, position: "bottom-right" });
      return of(PostEtrmConfigFailedAction(ConfigurationManagementEnum.UnableToPostEtrmConfig));
    }
  }),
    map((response: boolean) => {
      toast.success(ConfigurationManagementEnum.EtrmConfigPostSuccess, { autoClose: 3000, draggable: true, position: "bottom-right" });
    return PostEtrmConfigSuccessAction();
    }),
    catchError((x) => {
      console.error(x);
      toast.error(ConfigurationManagementEnum.UnableToGetEtrmConfig, { autoClose: 3000, draggable: true, position: "bottom-right" });
      return of(FetchEtrmConfigFailedAction(ConfigurationManagementEnum.UnableToGetEtrmConfig));
    })
  );


